"use client"
import { useTranslations } from "next-intl"

import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogBody,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from "@/components/ui/alert-dialog"
import { Loader2 } from "lucide-react"

interface CancelPrivateListingDialogProps {
  open: boolean
  onOpenChange: (open: boolean) => void
  title?: string
  description?: string
  confirmLabel?: string
  isProcessing?: boolean
  errorMessage?: string | null
  onConfirm: () => void
}

export function CancelPrivateListingDialog({
  open,
  onOpenChange,
  title: titleProp,
  description: descriptionProp,
  confirmLabel: confirmLabelProp,
  isProcessing = false,
  errorMessage,
  onConfirm,
}: CancelPrivateListingDialogProps) {
  const t = useTranslations("common");
  const tChat = useTranslations("chat");
  const title = titleProp ?? tChat("cancelItemTitle");
  const description = descriptionProp ?? tChat("cancelItemDesc");
  const confirmLabel = confirmLabelProp ?? tChat("cancelItem");
  return (
    <AlertDialog open={open} onOpenChange={onOpenChange}>
      <AlertDialogContent className="w-[calc(100vw-2rem)] sm:w-full">
        <AlertDialogHeader>
          <AlertDialogTitle>{title}</AlertDialogTitle>
        </AlertDialogHeader>
        <AlertDialogBody>
          <AlertDialogDescription>
            <span className="block">{description}</span>
            {errorMessage ? (
              <span className="block mt-2 text-destructive font-medium">{errorMessage}</span>
            ) : null}
          </AlertDialogDescription>
        </AlertDialogBody>
        <AlertDialogFooter>
          <AlertDialogCancel disabled={isProcessing}>{t("cancel")}</AlertDialogCancel>
          <AlertDialogAction
            onClick={onConfirm}
            disabled={isProcessing}
            className="bg-destructive text-destructive-foreground hover:bg-destructive/90"
          >
            {isProcessing ? <Loader2 className="h-4 w-4 animate-spin" /> : confirmLabel}
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  )
}

